import { CircleSVG } from 'common/assets';
import Text from 'components/elements/text';
import BillingAddressField from 'legacy-modules/master/common/billing-address-field';
import {
  CardSection,
  FullContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { AgentFormType } from './form-type';

export default function BillingAddressCard() {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useFormContext<AgentFormType>();

  return (
    <CardSection>
      <FullContainer style={{ display: 'flex' }}>
        <Text variant="HeadingXSmall">{t('customer:billing_address')}</Text>
        {errors.billings?.message && <CircleSVG />}
      </FullContainer>
      <SeparatorVertical $margin={16}>
        <Text variant="LabelSmall" color="#D44333">
          {errors.billings?.message}
        </Text>
      </SeparatorVertical>
      <BillingAddressField name="billings" />
    </CardSection>
  );
}
